import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useSalesArgument, useUpdateSalesArgument, useRemoveSalesArgument } from "../hooks";
import { SalesArgumentForm } from "../components";

type IUpdateSalesArgument = {
  id: string;
};

export const UpdateSalesArgument: React.FC = () => {
  const { id } = useParams<IUpdateSalesArgument>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useSalesArgument(+id!);
  const [remove] = useRemoveSalesArgument();
  const { form, submit, loading } = useUpdateSalesArgument({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("L'argumentaire a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.salesArgument?.ok && data?.salesArgument?.result) {
      form.setValue("theme", data.salesArgument.result.theme);
      form.setValue("content", data.salesArgument.result.content);
    }
  }, [data]);

  const handleRemove = async () => {
    if (!window.confirm("Supprimer cet argumentaire ? Cette action est irréversible.")) return;
    try {
      const { data } = await remove({ variables: { id: +id! } });
      if (data?.removeSalesArgument?.ok) {
        toast.success("L'argumentaire a été supprimé");
        navigate("/sales-arguments");
      } else {
        toast.error(data?.removeSalesArgument?.error ?? "Une erreur est survenue");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Argumentaire"
        subtitle={data?.salesArgument?.result?.theme ?? ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/sales-arguments`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier l'argumentaire" />
          <SalesArgumentForm loading={loading} form={form} submit={submit} />
          <div className="w-full mt-3 flex justify-end">
            <span
              className="text-red-600 text-sm cursor-pointer hover:underline"
              onClick={handleRemove}
            >
              Supprimer cet argumentaire
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
